/**
 * All DRO Readings page (spec 7). The spec left these decisions TBD (7.5); the agreed defaults live here so each can
 * be changed in one place:
 * - Apps: both Sales and Service list the page (`apps`).
 * - Access: the app's own menu permission (MenuItem_DROReadings in Service, menuItem_DROReadings in Sales).
 * - Service department: no filtering — every reading is listed.
 * - Filters: the standard RIMS grid furniture only (search, column filters, column chooser, Excel export).
 */
export const DRO_ALL_READINGS_SETTINGS = {
  apps: ['sales', 'service'] as string[],
  route: 'dro-readings',
  menuText: 'DRO Readings',
  menuIcon: 'fas fa-gauge-high'
};
